import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { media } from '../../../styles/style-utils';
import GiftUp from './GiftUp';
import { withRouteData } from 'react-static';

const Wrapper = styled.div`
  ${media.mediumLarge`
    height: ${props => (props.height ? `calc(${props.height}px - 21px)` : '626px')};
  `}

  .gift-up-target {
    width: 100%;
  }
`;

class GiftCard extends React.Component {
  state = {
    giftUpHeight: 0,
  };

  render() {
    return (
      <Wrapper height={this.state.giftUpHeight} id="embedded-gift-card">
        <GiftUp setGiftUpHeight={this.setGiftUpHeight} content={this.props.content} />
      </Wrapper>
    );
  }

  setGiftUpHeight = el => {
    const giftUpRef = el[0].target;
    this.setState({
      giftUpHeight: giftUpRef.offsetHeight,
    });
  };
}

export default withRouteData(GiftCard);

GiftCard.propTypes = {
  content: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/giftCard/GiftCard.js